import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';

import { AuthenticationService } from './../services/authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['../../../../node_modules/materialize-css/dist/css/materialize.min.css']
})
export class LoginComponent implements OnInit {
  isAuthenticated:boolean;
  constructor(private router:Router,private authenticationService:AuthenticationService) { 
   }

  ngOnInit() {
  }

  public loginForm = new FormGroup({
    email: new FormControl(),
    password: new FormControl()
  });

  login(){   

    if(this.loginForm.value.email != ""){
      this.authenticationService.login(this.loginForm.value.email,this.loginForm.value.password)
      .subscribe(data=> {
         if(data){
          //window.location.reload();
           this.router.navigate(['home']);
           //window.location.reload();
         }        
        });
    }
  }
}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/authentication/login/login.component.ts